export const GENERAL_WIZARD_TEXT = {
  step: 'define',
  title: 'Define QR Code',
  description: 'Start by defining QR Code title that is relevant and easy to understand.',
} as const;
